module.exports = __webpack_public_path__ + "static/media/keyboard_double_arrow_right.1ad46fb3.svg";